import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { ToastModule } from 'primeng/toast';

import { ComponentsModule } from '../../../components/components.module';
import { BrevoConfigComponent } from './brevo-config.component';

@NgModule({
    declarations: [BrevoConfigComponent],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ButtonModule,
        InputTextModule,
        PanelModule,
        ToastModule,
        ComponentsModule
    ],
    exports: [BrevoConfigComponent]
})
export class BrevoConfigModule {}
